import React, { FC, useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import moment from 'moment'
import cookie from 'react-cookies'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import { notify } from 'react-notify-toast'
import { useHistory } from 'react-router-dom'
import { usePromiseTracker, trackPromise } from 'react-promise-tracker'
// import { VoiceFocusDeviceTransformer } from 'amazon-chime-sdk-js'

// import { useSelector } from 'react-redux'
import { obtainFolderVideos } from '../../Api/base'

import {
  voteToKickUser,
  voteToMuteUser,
  voteKickDeleteUser,
  chimeCameraOffUser,
  chimeSelfMuteUser,
} from '../../Api/ChimeApi'

import { History, LocationState } from 'history'

// chime sdk improts
import {
  ConsoleLogger,
  DefaultDeviceController,
  DefaultMeetingSession,
  LogLevel,
  MeetingSessionConfiguration,
  DefaultModality,
  VoiceFocusTransformDevice,
  VoiceFocusDeviceTransformer,
} from 'amazon-chime-sdk-js'

// own Logic imports
import { getMeetingWithAttendies } from '../../Api/ChimeApi'
import { getSpecificVideo } from '../../Api/videoApi'
// own Views imports
import SingleRoom from './views/SingleRoom'
import { ListItemSecondaryAction } from '@material-ui/core'
import getStoredState from 'redux-persist/es/integration/getStoredStateMigrateV4'
import { forEach } from 'lodash'

interface ConferencesSingleRoomProps {
  Props: Props
}

interface Props {
  history: History
  location: LocationState & iMeeting
}

export interface iAudioVideoDevice {
  deviceId: string
  groupId: string
  kind: string
  label: string
}

interface iMeeting {
  MediaPlacement: {
    AudioFallbackUrl: string
    AudioHostUrl: string
    ScreenDataUrl: string
    ScreenSharingUrl: string
    ScreenViewingUrl: string
    SignalingUrl: string
    TurnControlUrl: string
  }
  MediaRegion: string
  MeetingId: string
}

const ConferencesSingleRoom: FC<ConferencesSingleRoomProps> = (props: any) => {
  const store = useSelector((state) => state)
  const location = useLocation()
  let history = useHistory()
  const appAllfolders = useSelector((state: any) => state.folders.folders)

  const getMeetingData = async () => {
    const meetingData: any = await getMeetingWithAttendies()

    if (
      meetingData &&
      meetingData.meeting !== null &&
      meetingData.meeting &&
      meetingData.attendee &&
      meetingData.attendee !== null
    ) {
      setMeeting(meetingData.meeting)
      setAttendee(meetingData.attendee)
    }
  }

  useEffect(() => {
    getMeetingData()
  }, [])

  const { userQueuedRoomKey, userChoosedVideo } = location.state

  const [meeting, setMeeting] = useState(Object)
  const [attendee, setAttendee] = useState(Object)

  const [listOfAudioInputDevices, setListOfAudioInputDevices] = useState<
    iAudioVideoDevice[]
  >([])
  const [listOfVideoDevices, setListOfVideoDevices] = useState<
    iAudioVideoDevice[]
  >([])
  const [listOfAudioOutputDevices, setListOfAudioOutputDevices] = useState<
    iAudioVideoDevice[]
  >([])
  const [currentMeetingSession, setCurrentMeetingSession] = useState(Object)
  const [masterMeetingSession, setMasterMeetingSession] = useState(Object)
  const [isUserMuted, setUserMuted] = useState(false)
  const [muteAttendeeId, setMuteAttendeeId] = useState(Object)
  const [masterVideo, setMasterVideo] = useState({})
  const [conferences, setNewConferences] = useState(Object)
  const [userId, setUserId] = useState(null)
  const [forceMute, setUserForceMuted] = useState(false)
  const [kickAttendeeId, setKickAttendeeId] = useState(Object)
  const [kickAttendeeFirebaseIndex, setKickAttendeeFirebaseIndex] =
    useState(null)
  const [muteAttendeeFirebaseIndex, setMuteAttendeeFirebaseIndex] =
    useState(null)
  const [currentRoom, setCurrentRoom] = useState(Object)
  const [videoStartingTime, setVideoStartingTime] = useState('')
  const [timeToTrainingInMs, setTimeToTrainingInMs] = useState(null)
  const [startTimeTrainingMs, setStartTimeTrainingMs] = useState(null)
  // const [intervalTime, setIntervalTime] = useState(timeToTrainingInMs)

  const [miazgaFolderName, setMiazgaFolderName] = useState('')
  const [miazgaFolderVideos, setMiazgaFolderVideos] = useState()
  const [miazgaFolderCurrentVideo, setMiazgaFolderCurrentVideo] =
    useState(Object)
  const [miazgaFolderCurrentVideoUri, setMiazgaFolderCurrentVideoUri] =
    useState(null)
  const [showVideoBanner, setShowVideoBanner] = useState(false)
  const [isIntervalSet, setIsIntervalSet] = useState(false)
  const [shouldPlayVideo, setShouldPlayVideo] = useState(false)
  const [startTimeJsDate, setStartTimeJsDate] = useState(null)
  const [timeNotSet, setTimeNotSet] = useState(false)
  const [isCameraOff, setCameraOff] = useState(false)
  const [mutedUsers, setMutedUsers] = useState([])
  const [cameraOffUsers, setCameraOffUsers] = useState([])
  const [videoOrder, setVideoOrder] = useState(null)
  const [allFoldersRequestDone, setAllFoldersRequestDone] = useState(false)

  // user chosen devices state
  const [chosenUserAudioInDevice, setChosenUserAudioInDevice] =
    useState<iAudioVideoDevice>()
  const [chosenUserAudioOutDevice, setChosenUserAudioOutDevice] =
    useState<iAudioVideoDevice>()

  const [chosenUserVideoDevice, setChosenUserVideoDevice] =
    useState<iAudioVideoDevice>()
  const { promiseInProgress } = usePromiseTracker()

  // Obtain user id
  useEffect(() => {
    setUserId(setUserIdent())
  }, [attendee])

  useEffect(() => {
    setConfig()
    listenForFirebaseChange()
  }, [attendee, meeting])

  useEffect(() => {
    getListOfDevices()
    // subscribeToSignalEvents()
    //  setMasterAttendeeVideoSource()
  }, [currentMeetingSession])

  useEffect(() => {
    setChosenAudioVideoSources()

    return () => {
      if (currentMeetingSession.audioVideo) {
        currentMeetingSession.audioVideo.chooseVideoInputDevice(null)
        currentMeetingSession.audioVideo.stopLocalVideoTile()
        currentMeetingSession.audioVideo.stop()
        // currentMeetingSession.audioVideo.stopVideoPreviewForVideoInput(previewVideoElement);
      }
    }
  }, [listOfAudioInputDevices, listOfVideoDevices, listOfAudioOutputDevices])

  // in case user is voted to mute and muteAttendeeId value changes

  useEffect(() => {
    if (muteAttendeeId && meeting && meeting.pk) {
      voteToMuteUser(
        muteAttendeeId.muteId,
        meeting.pk,
        muteAttendeeId.muteIndexKey
      )

      setMuteAttendeeId(null)
    }
  }, [muteAttendeeId])

  useEffect(() => {
    if (kickAttendeeId && meeting && meeting.pk) {
      voteKickDeleteUser(
        kickAttendeeId.kickId,
        meeting.pk,
        kickAttendeeId.kickIndexKey
      )
      setKickAttendeeId(null)
    }
  }, [kickAttendeeId])

  useEffect(() => {
    checkIfImMutedOrKickedUser()
    obtainRoomVideo()

    checkStartVideoTime()
    // checkIfImMutedUser()
  }, [conferences])

  useEffect(() => {
    checkMutedUsers()

    setTimeout(() => {
      if (
        document.querySelectorAll('.user-name').length > 0 &&
        conferences.rooms
      ) {
        document
          .querySelectorAll('.user-name')
          .forEach((userNameElement: any) => {
            if (
              currentRoom &&
              conferences.rooms &&
              conferences.rooms != undefined &&
              conferences.rooms != null &&
              conferences.rooms[currentRoom.key] &&
              userNameElement.id &&
              conferences.rooms[currentRoom.key].users &&
              conferences.rooms[currentRoom.key].users != undefined &&
              conferences.rooms[currentRoom.key].users != null
            ) {
              for (const key of Object.keys(
                conferences.rooms[currentRoom.key].users
              )) {
                if (
                  conferences.rooms[currentRoom.key].users[key].user_id ==
                  userNameElement.id
                ) {
                  userNameElement.innerHTML =
                    conferences.rooms[currentRoom.key].users[key].user_name
                }
              }
            }
          })
      }
    }, 2000)
  }, [currentRoom, conferences])

  // attempt to gather video url

  useEffect(() => {
    let videoId: any

    if (userChoosedVideo) {
      videoId = userChoosedVideo.uri.split('/')[2]

      getMasterMiazgaVideoInfo(videoId)
    }
  }, [userChoosedVideo])

  useEffect(() => {
    shouldShowVideoTimeBanener()
    checkIfShouldPlayVideo()
  }, [videoStartingTime])

  useEffect(() => {
    var today = new Date()

    var time =
      today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()

    // const jsCurrentTimeMs = new Date().getTime()
    // const jsStartVideoTimeMs = moment(videoStartingTime, 'HH:mm:ss').valueOf()
    // const msPassedFromVideoStartTime =
    //   (jsCurrentTimeMs - jsStartVideoTimeMs) / 1000

    if (conferences && conferences.sessions && userChoosedVideo) {
      if (
        moment().valueOf() >
          moment(conferences.sessions[0].start_video).valueOf() &&
        moment().valueOf() <
          moment(conferences.sessions[0].start_video).valueOf() +
            userChoosedVideo.duration * 1000
      ) {
        setShouldPlayVideo(true)
        setShowVideoBanner(false)
        const videoStart: any = moment(
          conferences.sessions[0].start_video
        ).valueOf()

        setStartTimeJsDate(videoStart)
      } else {
        setShouldPlayVideo(false)
        // setShowVideoBanner(true)
      }
    }

    const interval = setInterval(() => {
      setTimeToTrainingInMs(
        (timeToTrainingInMs: any) => timeToTrainingInMs - 1000
      )

      if (timeToTrainingInMs && timeToTrainingInMs - 1000 <= 0) {
      }

      if (timeToTrainingInMs > 0) {
        setShouldPlayVideo(false)
        setShowVideoBanner(true)
      } else {
        setShouldPlayVideo(true)
        setShowVideoBanner(false)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [timeToTrainingInMs, userChoosedVideo])

  useEffect(() => {
    if (isUserMuted) {
      // const userRef = firebase
      //   .database()
      //   .ref(`/rooms/${userQueuedRoomKey}/users/${userFirebaseIndexKey}`)

      // userRef.update({
      //   is_user_self_muted: true,
      // })
      chimeSelfMuteUser(userQueuedRoomKey, userId, true)
      notify.show('Wyciszono mikrofon', 'warning', 2000)
    } else {
      // const userRef = firebase
      //   .database()
      //   .ref(`/rooms/${userQueuedRoomKey}/users/${userFirebaseIndexKey}`)

      // userRef.update({
      //   is_user_self_muted: false,
      // })
      chimeSelfMuteUser(userQueuedRoomKey, userId, false)
      notify.show('Mikrofon aktywny', 'success', 2000)
    }
  }, [isUserMuted])

  useEffect(() => {
    if (isCameraOff) {
      // const userRef = firebase
      //   .database()
      //   .ref(`/rooms/${userQueuedRoomKey}/users/${userFirebaseIndexKey}`)

      // userRef.update({
      //   is_user_camera_off: true,
      // })
      chimeCameraOffUser(userQueuedRoomKey, userId, true)
      notify.show('Wyłączono obraz z kamery', 'warning', 2000)
    } else {
      // const userRef = firebase
      //   .database()
      //   .ref(`/rooms/${userQueuedRoomKey}/users/${userFirebaseIndexKey}`)

      // userRef.update({
      //   is_user_camera_off: false,
      // })
      chimeCameraOffUser(userQueuedRoomKey, userId, false)
      notify.show('Obraz z kamery aktywny', 'success', 2000)
    }
  }, [isCameraOff])

  useEffect(() => {
    setTimeout(() => {
      if (document.querySelectorAll('.mute-indicator').length) {
        document
          .querySelectorAll('.mute-indicator')
          .forEach((muteIndicatorElement: any) => {
            muteIndicatorElement.id = parseInt(
              muteIndicatorElement.nextElementSibling.id.split('-')[0]
            )
          })
      }
    }, 2000)
  }, [conferences])

  useEffect(() => {
    if (document.querySelectorAll('.mute-indicator').length) {
      document
        .querySelectorAll('.mute-indicator')
        .forEach((muteIndicatorElement: any) => {
          // Check whether any remote stream is muted
          if (
            muteIndicatorElement.nextElementSibling.id &&
            muteIndicatorElement.nextElementSibling.className.includes(
              'videoChime'
            )
          ) {
            if (
              mutedUsers.includes(
                parseInt(
                  muteIndicatorElement.nextElementSibling.id.split('-')[0]
                )
              )
            ) {
              muteIndicatorElement.classList.add('muted-user')
            } else {
              muteIndicatorElement.classList.remove('muted-user')
            }
          }

          // check if user local stream is muted

          if (
            muteIndicatorElement.nextElementSibling.id &&
            muteIndicatorElement.nextElementSibling.id == 'videoEl'
          ) {
            if (mutedUsers.includes(userId)) {
              muteIndicatorElement.classList.add('muted-user')
            } else {
              muteIndicatorElement.classList.remove('muted-user')
            }
          }
        })
    }
    setTimeout(() => {
      if (document.querySelectorAll('.camera-off-tile').length) {
        document
          .querySelectorAll('.camera-off-tile')
          .forEach((cameraOffTileElement: any) => {
            // Check whether any remote stream is muted
            if (
              cameraOffTileElement.previousSibling.id &&
              cameraOffTileElement.previousSibling.className.includes(
                'videoChime'
              )
            ) {
              if (
                cameraOffUsers.includes(
                  parseInt(
                    cameraOffTileElement.previousSibling.id.split('-')[0]
                  )
                )
              ) {
                cameraOffTileElement.classList.add('camera-off-user')
                cameraOffTileElement.parentElement.classList.add(
                  'camera-off-user'
                )
              } else {
                cameraOffTileElement.classList.remove('camera-off-user')
                cameraOffTileElement.parentElement.classList.remove(
                  'camera-off-user'
                )
              }
            }

            // // check if user local stream is muted

            // if(cameraOffTileElement.previousSibling.id && cameraOffTileElement.previousSibling.id == "videoEl"){

            //   if(mutedUsers.includes(userId)){
            //     muteIndicatorElement.classList.add("muted-user")

            //   }else{
            //     muteIndicatorElement.classList.remove("muted-user")
            //   }
            // }
          })
      }
    }, 10)
  }, [mutedUsers, cameraOffUsers])

  //USEEFFECTS END

  const checkMutedUsers = () => {
    if (
      currentRoom &&
      conferences.rooms &&
      conferences.rooms[currentRoom.key] &&
      conferences.rooms[currentRoom.key].users &&
      typeof conferences.rooms[currentRoom.key].users == 'object' &&
      conferences.rooms[currentRoom.key].users != null
    ) {
      for (const key of Object.keys(conferences.rooms[currentRoom.key].users)) {
        // CHECK IF USER IS SELF MUTED
        if (conferences.rooms[currentRoom.key].users[key].is_user_self_muted) {
          if (
            !mutedUsers.includes(
              conferences.rooms[currentRoom.key].users[key].user_id
            )
          ) {
            setMutedUsers([
              ...mutedUsers,
              conferences.rooms[currentRoom.key].users[key].user_id,
            ])
          }
        } else {
          if (
            mutedUsers.includes(
              conferences.rooms[currentRoom.key].users[key].user_id
            )
          ) {
            // let index = mutedUsers.indexOf(conferences.rooms[currentRoom.key].users[key].user_id);

            let filteredAry = mutedUsers.filter(
              (e: any) =>
                e !== conferences.rooms[currentRoom.key].users[key].user_id
            )
            setMutedUsers(filteredAry)
          }
        }

        // CHECK IF USER TURNED OFF CAMERA

        if (conferences.rooms[currentRoom.key].users[key].is_user_camera_off) {
          if (
            !cameraOffUsers.includes(
              conferences.rooms[currentRoom.key].users[key].user_id
            )
          ) {
            setCameraOffUsers([
              ...cameraOffUsers,
              conferences.rooms[currentRoom.key].users[key].user_id,
            ])
          }
        } else {
          if (
            cameraOffUsers.includes(
              conferences.rooms[currentRoom.key].users[key].user_id
            )
          ) {
            // let index = mutedUsers.indexOf(conferences.rooms[currentRoom.key].users[key].user_id);

            let filteredAry = cameraOffUsers.filter(
              (e: any) =>
                e !== conferences.rooms[currentRoom.key].users[key].user_id
            )
            setCameraOffUsers(filteredAry)
          }
        }
      }
    }
  }

  const getMasterMiazgaVideoInfo = async (videoId: string) => {
    const video = await getSpecificVideo(videoId)

    if (video) {
      setMasterVideo(video)
    }
  }

  const gatherKickedOrMutedUserFirebaseIndex = (userId: number) => {
    let userFirebaseIndex

    conferences.rooms &&
      conferences.rooms.forEach((room: any) => {
        if (room.users && Object.keys(room.users).length) {
          for (const key of Object.keys(room.users)) {
            if (
              room.users[key].user_id &&
              room.users[key].user_id !== undefined &&
              room.users[key].user_id === userId
            ) {
              userFirebaseIndex = key

              return userFirebaseIndex
            }
          }
        }
      })

    return userFirebaseIndex
  }

  const setUserIdent = () => {
    let userId: number
    if (attendee && attendee.ExternalUserId) {
      userId = parseInt(attendee.ExternalUserId.split('-')[0])
    }

    return userId
  }
  const setConfig = () => {
    const logger = new ConsoleLogger('MyLogger', LogLevel.INFO)
    const deviceController = new DefaultDeviceController(logger, {
      enableWebAudio: true,
    })

    if (
      Object.keys(attendee).length !== 0 &&
      Object.keys(meeting).length !== 0
    ) {
      const configuration = new MeetingSessionConfiguration(meeting, attendee)

      const meetingSession = new DefaultMeetingSession(
        configuration,
        logger,
        deviceController
      )
      // store meeting session informations in state
      setCurrentMeetingSession(meetingSession)
    }
  }

  const checkIfShouldPlayVideo = () => {
    if (videoStartingTime) {
      const format = 'HH:mm:ss'

      const time: any = moment().format(format)
      const videoStart: any = moment(videoStartingTime, 'HH:mm:ss').format(
        format
      )

      if (time >= videoStart) {
        setShouldPlayVideo(true)
        setShowVideoBanner(false)
      }
    }
  }

  const shouldShowVideoTimeBanener = async () => {
    if (videoStartingTime) {
      const format = 'HH:mm:ss'

      const time: any = moment().format(format)

      // const momentCurrentTime = moment()
      // const momentVideoTime = moment(videoStartingTime)

      const videoStart: any = moment(videoStartingTime, 'HH:mm:ss').format(
        format
      )

      if (time < videoStart) {
        const timeDiff = moment(time, 'HH:mm:ss').diff(
          moment(videoStart, 'HH:mm:ss')
        )
        setTimeToTrainingInMs(-timeDiff)
      } else {
        const timeDiff = moment(time, 'HH:mm:ss').diff(
          moment(videoStart, 'HH:mm:ss')
        )
        setStartTimeTrainingMs(-timeDiff)
      }
    }
  }

  const getListOfDevices = async () => {
    // First list all of user available devices (audio in/out and video)

    if (Object.keys(currentMeetingSession).length !== 0) {
      const audioInputDevices =
        await currentMeetingSession?.audioVideo.listAudioInputDevices()

      const audioOutputDevices =
        await currentMeetingSession?.audioVideo.listAudioOutputDevices()
      const videoInputDevices =
        await currentMeetingSession?.audioVideo.listVideoInputDevices()

      //  now set this devices in state

      audioInputDevices.forEach((deviceInfo: any) => {
        setListOfAudioInputDevices([...listOfAudioInputDevices, deviceInfo])
      })

      audioOutputDevices.forEach((deviceInfo: any) => {
        setListOfAudioOutputDevices([...listOfAudioOutputDevices, deviceInfo])
      })

      videoInputDevices.forEach((deviceInfo: any) => {
        setListOfVideoDevices([...listOfVideoDevices, deviceInfo])
      })
    }
  }

  const listenForFirebaseChange = () => {
    var queueDataRef = firebase.database().ref('/')
    queueDataRef.on('value', (snapshot) => {
      const data = snapshot.val()
      setNewConferences(data)
    })
  }

  // if there are  correctly set in state user devices now we can set those devices into sdk

  const setChosenAudioVideoSources = async () => {
    if (
      Object.keys(currentMeetingSession).length !== 0 &&
      listOfAudioInputDevices.length &&
      listOfAudioInputDevices.length &&
      listOfVideoDevices.length
    ) {
      // settings for voicefocustransformer:
      // variant: "c100" | "c50" | "c20" | "c10"
      // simd : "force" | "disable" | "detect"
      // executionPreference: "worker" | "auto"
      // executionQuantaPreference: 1 | 2 | 3
      // usagePreference: "quality" | "interactivity"
      //
      // GOOD ONES:
      // category: 'voicefocus',

      //       simd: 'disable',
      //       executionPreference: 'worker',
      //       executionQuantaPreference: 1,
      //       usagePreference: 'quality',

      // THE BEST ONES
      // category: 'voicefocus',

      //       simd: 'disable',
      //       executionPreference: 'auto',
      //       executionQuantaPreference: 1,
      //       usagePreference: 'quality',

      if (listOfAudioInputDevices.length) {
        currentMeetingSession.voiceFocusDeviceTransformer =
          await VoiceFocusDeviceTransformer.create({
            category: 'voicefocus',

            simd: 'disable',
            executionPreference: 'auto',
            executionQuantaPreference: 2,
            usagePreference: 'quality',
          })

        currentMeetingSession.voiceFocusTransformDevice =
          await currentMeetingSession.voiceFocusDeviceTransformer.createTransformDevice(
            listOfAudioInputDevices.length
              ? listOfAudioInputDevices[0].deviceId
              : null
          )

        currentMeetingSession.audioVideo.chooseAudioInputDevice(
          currentMeetingSession.voiceFocusTransformDevice
        )

        // await currentMeetingSession.audioVideo.chooseAudioInputDevice(
        //   listOfAudioInputDevices.length
        //     ? listOfAudioInputDevices[0].deviceId
        //     : null
        // )
      }

      await currentMeetingSession.audioVideo.chooseAudioOutputDevice(null)

      await currentMeetingSession.audioVideo.start()

      handleAudio()

      startLocalTile()

      startRemoteTiles()
    }
  }

  const checkIfImMutedOrKickedUser = () => {
    // On databse change (occur when vote for mute user pass and value appear in database is_user_muted on true)

    // 1. find myself on database
    const roomRef = firebase
      .database()
      .ref(`/rooms/${userQueuedRoomKey}/users/`)

    roomRef.once('value').then(async (snapshot) => {
      if (snapshot.val() !== null && snapshot.val() !== undefined) {
        for (const key of Object.keys(snapshot.val())) {
          if (userId !== null) {
            // if user is muted by vote
            if (
              snapshot.val()[key].is_user_muted == true &&
              userId == snapshot.val()[key].user_id
            ) {
              muteSelfByVote()
              return
            }

            // if user is muted by himself
            if (isUserMuted && snapshot.val()[key].is_user_muted == undefined) {
              muteSelf()
              setUserMuted(true)
              return
            }

            // if is user kicked
            if (
              snapshot.val()[key].is_user_kicked &&
              userId == snapshot.val()[key].user_id
            ) {
              notify.show(
                'Zostałeś/łąś w demokratycznych ludowych wyborach usunięta z komitetu spotkania ćwiczących narodu. Zaraz zostaniesz rozlokowana w inne miejsce towarzyszu/ko.',
                'error',
                5000
              )

              setTimeout(() => {
                history.push('/')
              }, 5500)

              return
            }

            //else if user is not kicked, not muted or muted by vote
            if (snapshot.val()[key].is_user_muted === undefined) {
              setUserForceMuted(false)
              setUserMuted(false)
              unMuteSelf()
            }
          }
        }
      }
    })
  }

  const checkStartVideoTime = () => {
    const roomKey: number = location.state.userQueuedRoomKey
    let sessionId: number

    conferences?.rooms?.forEach((room: any) => {
      if (room.key === roomKey) {
        setCurrentRoom(room)
        sessionId = room.session_id
      }
    })

    conferences?.sessions?.forEach((session: any) => {
      if (session.key === sessionId) {
        setVideoStartingTime(moment(session.start_video).format('HH:mm:ss'))
      }
    })
  }

  const muteSelf = () => {
    if (currentMeetingSession)
      currentMeetingSession.audioVideo.realtimeMuteLocalAudio()

    setUserMuted(true)
  }

  const muteSelfByVote = () => {
    if (currentMeetingSession)
      currentMeetingSession.audioVideo.realtimeMuteLocalAudio()

    setUserForceMuted(true)
  }

  const unMuteSelf = () => {
    if (currentMeetingSession.audioVideo) {
      setUserMuted(false)
      currentMeetingSession.audioVideo.realtimeUnmuteLocalAudio()
    }
  }

  const handleAudio = () => {
    const audioElement = document.getElementById('audioEl')
    const audioContext: AudioContext = new window.AudioContext()
    const destinationStream = audioContext.createMediaStreamDestination()

    currentMeetingSession.audioVideo.bindAudioElement(audioElement)

    const observer = {
      audioVideoDidStart: () => {
        console.log('Started audio stream')
      },

      audioVideoDidStop: (sessionStatus: any) => {
        // See the "Stopping a session" section for details.
        console.log(
          'Stopped with a session status code: ',
          sessionStatus.statusCode()
        )
      },
      audioVideoDidStartConnecting: (reconnecting: any) => {
        if (reconnecting) {
          // e.g. the WiFi connection is dropped.
          console.log('Attempting to reconnect')
        }
      },
    }

    currentMeetingSession.audioVideo.addObserver(observer)

    currentMeetingSession.audioVideo.start()

    const unmuted = currentMeetingSession.audioVideo.realtimeUnmuteLocalAudio()
    if (unmuted) {
      console.log('Other attendees can hear your audio')
    } else {
      // See the realtimeSetCanUnmuteLocalAudio use case below.
      console.log('You cannot unmute yourself')
    }
  }

  const startLocalTile = async () => {
    const videoElement = document.getElementById('videoEl')

    await currentMeetingSession.audioVideo.chooseVideoInputDevice(
      listOfVideoDevices[0].deviceId
    )

    const observer = {
      // videoTileDidUpdate is called whenever a new tile is created or tileState changes.
      videoTileDidUpdate: (tileState: any) => {
        // Ignore a tile without attendee ID and other attendee's tile.
        if (!tileState.boundAttendeeId || !tileState.localTile) {
          return
        }

        currentMeetingSession.audioVideo.bindVideoElement(
          tileState.tileId,
          videoElement
        )
      },
    }

    currentMeetingSession.audioVideo.addObserver(observer)
    currentMeetingSession.audioVideo.startLocalVideoTile()
  }

  const turnOffCamera = () => {
    currentMeetingSession.audioVideo.stopLocalVideoTile()
    setCameraOff(true)
  }

  const turnOnCamera = () => {
    currentMeetingSession.audioVideo.startLocalVideoTile()
    setCameraOff(false)
  }

  const startRemoteTiles = () => {
    const videoElements = document.querySelectorAll('.videoChime')

    // index-tileId pairs
    const indexMap: any = {}

    const acquireVideoElement = (tileId: any, attendeeId: string) => {
      // Return the same video element if already bound.
      for (let i = 0; i < 8; i += 1) {
        if (indexMap[i] === tileId) {
          videoElements[i].id = attendeeId
          videoElements[i].parentElement.classList.add('visible')

          let siblings = videoElements[i].parentElement.childNodes
          siblings.forEach((sibling: any) => {
            if (sibling.classList.contains('user-name')) {
              sibling.id = attendeeId.split('-')[0]
              // sibling.innerHTML = getUserName(parseInt(attendeeId.split("-")[0]))
            }
          })

          return videoElements[i]
        }
      }
      // Return the next available video element.
      for (let i = 0; i < 8; i += 1) {
        if (!indexMap.hasOwnProperty(i)) {
          videoElements[i].id = attendeeId
          videoElements[i].parentElement.classList.add('visible')
          let siblings = videoElements[i].parentElement.childNodes
          siblings.forEach((sibling: any) => {
            if (sibling.classList.contains('user-name')) {
              sibling.id = attendeeId.split('-')[0]
            }
          })

          indexMap[i] = tileId
          return videoElements[i]
        }
      }
      throw new Error('no video element is available')
    }

    const releaseVideoElement = (tileId: any) => {
      for (let i = 0; i < 8; i += 1) {
        if (indexMap[i] === tileId) {
          videoElements[i].parentElement.classList.remove('visible')

          delete indexMap[i]
          return
        }
      }
    }

    const observer = {
      // videoTileDidUpdate is called whenever a new tile is created or tileState changes.
      videoTileDidUpdate: (tileState: any) => {
        // Ignore a tile without attendee ID, a local tile (your video), and a content share.
        if (
          !tileState.boundAttendeeId ||
          tileState.localTile ||
          tileState.isContent
        ) {
          return
        }

        currentMeetingSession.audioVideo.bindVideoElement(
          tileState.tileId,
          acquireVideoElement(tileState.tileId, tileState.boundExternalUserId)
        )
      },
      videoTileWasRemoved: (tileId: any) => {
        releaseVideoElement(tileId)
      },
    }

    currentMeetingSession.audioVideo.addObserver(observer)
  }

  const obtainRoomVideo = async () => {
    let requestDone = false
    // 1. gather firebase foldername in which queue user stays in
    let folderName: string
    let miazgaFolder: any
    let allFolderVideos: any
    const miazgaId: number = location.state.userChosedMiazgaId
    const videoId: number = location.state.userChosedVideoId

    if (conferences.folders && miazgaId !== null) {
      folderName = conferences.folders[miazgaId].folder_name
    }

    setMiazgaFolderName(folderName)

    // 2. Gather video path (uri) needed for obtainFolderVideos endpoint by filtering redux folders for currently set userPickedRoomMiazgaFolderName variable

    miazgaFolder =
      appAllfolders &&
      appAllfolders.filter((folder: any) => folder.name == folderName)

    // 3. obtain videos for picked folder by obtainFolderVideos endpoint and pass miazgaName

    if (
      miazgaFolder &&
      miazgaFolder.length &&
      miazgaFolder[0].uri &&
      !miazgaFolderVideos &&
      !allFoldersRequestDone &&
      !requestDone
    ) {
      let uri: any = miazgaFolder[0].uri.split('/')

      let correctPath: string = `/${uri[3]}/${uri[4]}/video/`

      allFolderVideos = await obtainFolderVideos(correctPath)

      setAllFoldersRequestDone(true)
      requestDone = true
    }

    // 4. Filter for correct uri for user room key which is same as foldervideo.tag VIDEO_ORDER_[roomkey]

    let correctVideoData: any
    if (allFolderVideos && allFolderVideos.length) {
      let sorted = []
      let unchangedFolders = allFolderVideos
      let unsorted = allFolderVideos
      let onlyNumber

      if (unsorted !== undefined) {
        unsorted.map((video: any) => {
          video.tags.forEach((tag: any) => {
            if (tag.tag.includes('VIDEO_ORDER')) {
              unchangedFolders.map((stateFolder: any) => {
                if (stateFolder.uri === video.uri) {
                  onlyNumber = tag.tag.replace(/VIDEO_ORDER_/g, '')
                  stateFolder.order = parseInt(onlyNumber)
                }
              })
            } else if (tag.tag.includes('POWITANIE')) {
              unchangedFolders.map((stateFolder: any) => {
                if (stateFolder.uri === video.uri) {
                  stateFolder.order = 0
                }
              })
            }
          })
        })

        sorted = unchangedFolders.sort(function (a: any, b: any) {
          return a.order - b.order
        })

        setMiazgaFolderVideos(sorted)

        let userRoomMiazgaVideo: any = sorted.filter(
          (video: any) => video.order == videoId
        )

        setMiazgaFolderCurrentVideo(userRoomMiazgaVideo)

        // 5. Finally Get specific room miazga video uri to pass for further component

        if (userRoomMiazgaVideo && userRoomMiazgaVideo.length) {
          setMiazgaFolderCurrentVideoUri(userRoomMiazgaVideo[0].uri)
        }
      }
    }
  }

  return (
    <SingleRoom
      listOfVideoDevices={listOfVideoDevices}
      listOfAudioOutputDevices={listOfAudioOutputDevices}
      listOfAudioInputDevices={listOfAudioInputDevices}
      setChosenUserAudioInDevice={setChosenUserAudioInDevice}
      setChosenUserAudioOutDevice={setChosenUserAudioOutDevice}
      setChosenUserVideoDevice={setChosenUserVideoDevice}
      chosenUserAudioInDevice={chosenUserAudioInDevice}
      chosenUserAudioOutDevice={chosenUserAudioOutDevice}
      chosenUserVideoDevice={chosenUserVideoDevice}
      muteSelf={muteSelf}
      unMuteSelf={unMuteSelf}
      isUserMuted={isUserMuted}
      muteAttendeeId={muteAttendeeId}
      setMuteAttendeeId={setMuteAttendeeId}
      masterVideo={masterVideo}
      forceMute={forceMute}
      kickAttendeeId={kickAttendeeId}
      setKickAttendeeId={setKickAttendeeId}
      gatherKickedOrMutedUserFirebaseIndex={
        gatherKickedOrMutedUserFirebaseIndex
      }
      setKickAttendeeFirebaseIndex={setKickAttendeeFirebaseIndex}
      setMuteAttendeeFirebaseIndex={setMuteAttendeeFirebaseIndex}
      kickAttendeeFirebaseIndex={kickAttendeeFirebaseIndex}
      muteAttendeeFirebaseIndex={muteAttendeeFirebaseIndex}
      promiseInProgress={promiseInProgress}
      timeToTrainingInMs={timeToTrainingInMs}
      showVideoBanner={showVideoBanner}
      shouldPlayVideo={shouldPlayVideo}
      miazgaFolderCurrentVideo={miazgaFolderCurrentVideo}
      videoStartingTime={videoStartingTime}
      // timeToTrainingInMs={timeToTrainingInMs}
      startTimeJsDate={startTimeJsDate}
      startTimeTrainingMs={startTimeTrainingMs}
      turnOffCamera={turnOffCamera}
      turnOnCamera={turnOnCamera}
      isCameraOff={isCameraOff}
      mutedUsers={mutedUsers}
      // getUserName={getUserName}
      conferences={conferences}
      currentRoom={currentRoom}
      setShowVideoBanner={setShowVideoBanner}
      miazgaFolderName={miazgaFolderName}
      userChoosedVideo={userChoosedVideo}
    />
  )
}

export default ConferencesSingleRoom
